import React, { Fragment, useEffect } from "react";
import {
  clearProductCategoryDetail,
  fetchDeleteProductCategory,
  fetchProductCategoryList,
} from "../actions/productCategory";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";
import { statusRender, statusSectorRender } from "../utils/cellRenderTable";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ProductCategoryList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "productCategory";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { productCategoryList } = useSelector(
    (state) => state.productCategoryReducer
  );

  useEffect(() => {
    dispatch(fetchProductCategoryList());
    dispatch(clearProductCategoryDetail());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/productCategory-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteProductCategory(pageId));
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("productCategory.country"),
      field: "countryName",
      filter: "agSetColumnFilter",
      width: 150,
    },
    {
      headerName: t("productCategory.parentCategory"),
      field: "parentName",
      filter: "agTextColumnFilter",
      width: 250,
    },
    {
      headerName: t("productCategory.categoryName"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 200,
    },
    {
      headerName: t("customerList.sectorName"),
      field: "sector",
      filter: "agSetColumnFilter",
      cellRenderer: statusSectorRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.sector) return null;
        switch (params.data.sector) {
          case "DEVICE_FOR_HOUSE":
            return t("global.DEVICE_FOR_HOUSE");
          case "TV_AUDIO":
            return t("global.TV_AUDIO");
          case "DEVICE_FOR_HOUSE_AND_TV_AUDIO":
            return t("global.DEVICE_FOR_HOUSE_AND_TV_AUDIO");
          default:
            return "";
        }
      },
    },
    {
      headerName: t("productCategory.position"),
      field: "position",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: t("productCategory.status"),
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "INACTIVE":
            return "Neaktivan";
          case "ACTIVE":
            return "Aktivan";
          default:
            return "";
        }
      },
      width: 150,
    },
    {
      headerName: t("productCategory.creationDate"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: t("productCategory.lastUpdateDate"),
      field: "updatedAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={productCategoryList}
        columnDefs={columnDefs}
        buttonLink={`/product-category-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"product-category-list"}
      />
    </Fragment>
  );
};

export default ProductCategoryList;
